namespace $ { $mol_style_attach( "mol/check/group/demo/demo.view.css",
 "[mol_check_group_demo] {\n\talign-items: flex-start;\n}\n\n[mol_check_group_demo_all] {\n\tbox-shadow: 0 1px 0 0px var(--mol_theme_line);\n}\n"
) }